const mutations = {
    setCurrentJob(state, job) {
        state.currentJob = job;
        if (job) {
            state.currentJobId = job.id;
        } else {
            state.currentJobId = null;
        }
    },
    setCurrentJobLoading(state, value) {
        state.currentJobLoading = value;
    },
    setPollHandle(state, handle) {
        state.pollHandle = handle;
    },
    clearPollHandle(state) {
        if (state.pollHandle) {
            clearInterval(state.pollHandle);
        }
        state.pollHandle = null;
    },
    setJobsList(state, { items, total }) {
        state.jobsList = items || [];
        if (typeof total === "number") {
            state.jobsListTotal = total;
        } else if (items) {
            state.jobsListTotal = items.length;
        } else {
            state.jobsListTotal = 0;
        }
    },
    setJobsListLoading(state, value) {
        state.jobsListLoading = value;
    },
    setUploadInFlight(state, value) {
        state.uploadInFlight = value;
    },
    setVideoCurrentUpload(state, upload) {
        state.videoCurrentUpload = upload;
        if (upload) {
            state.videoCurrentUploadId = upload.uploadId || upload.id;
        } else {
            state.videoCurrentUploadId = null;
        }
    },
    setVideoCurrentUploadLoading(state, value) {
        state.videoCurrentUploadLoading = value;
    },
    setVideoPollHandle(state, handle) {
        state.videoPollHandle = handle;
    },
    clearVideoPollHandle(state) {
        if (state.videoPollHandle) {
            clearInterval(state.videoPollHandle);
        }
        state.videoPollHandle = null;
    },
    setVideoUploadsList(state, { items, total }) {
        state.videoUploadsList = items || [];
        if (typeof total === "number") {
            state.videoUploadsListTotal = total;
        } else if (items) {
            state.videoUploadsListTotal = items.length;
        } else {
            state.videoUploadsListTotal = 0;
        }
    },
    setVideoUploadsListLoading(state, value) {
        state.videoUploadsListLoading = value;
    },
    setVideoUploadInFlight(state, value) {
        state.videoUploadInFlight = value;
    },
    setScenariosList(state, items) {
        state.scenariosList = items || [];
    },
    setScenariosListLoading(state, value) {
        state.scenariosListLoading = value;
    },
    setAlarmsList(state, { items, total }) {
        state.alarmsList = items || [];
        if (typeof total === "number") {
            state.alarmsListTotal = total;
        } else if (items) {
            state.alarmsListTotal = items.length;
        } else {
            state.alarmsListTotal = 0;
        }
    },
    setAlarmsListLoading(state, value) {
        state.alarmsListLoading = value;
    },
    setSystemConfig(state, items) {
        state.systemConfig = items || [];
    },
    setSystemConfigLoading(state, value) {
        state.systemConfigLoading = value;
    },
    setExclusionsList(state, items) {
        state.exclusionsList = items || [];
    },
    setExclusionsListLoading(state, value) {
        state.exclusionsListLoading = value;
    },
    setPersonDetail(state, person) {
        state.personDetail = person;
    },
    setPersonDetailLoading(state, value) {
        state.personDetailLoading = value;
    },
    setPersonMatchHistory(state, items) {
        state.personMatchHistory = items || [];
    },
    setPersonMatchHistoryLoading(state, value) {
        state.personMatchHistoryLoading = value;
    },
    setCoPresence(state, data) {
        state.coPresenceData = data;
    },
    setCoPresenceKimlikno(state, kimlikno) {
        state.coPresenceKimlikno = kimlikno;
    },
    setCoPresenceLoading(state, value) {
        state.coPresenceLoading = value;
    }
};

export default mutations;